import ScalarErrorBoundary_default from "./ScalarErrorBoundary.vue.js";
export { ScalarErrorBoundary_default as ScalarErrorBoundary };
